import { memo } from "react";
import { Link } from "react-router-dom";
import "./ft.css";

import { getProductImageUrl } from "../../../../utils/imageUrl";

function Featurelist({ data, count, show = "yes" }) {
	if (!data) return null;
	const primaryImage = getProductImageUrl(data, 0);
	const hoverImage = getProductImageUrl(data, 1);

	return (
		<div className={count === 1 ? "lg:w-10/12" : ""}>
			<li className={`${count === 1 ? "block gap-5 md:flex lg:flex" : "w-full"} group`}>
				<Link
					to={`/product/id/${data.style}`}
					state={{ product: data, className: "object-cover object-top" }}
					aria-label={`View Azure style ${data.style}`}
				>
					<div className={`relative overflow-hidden ${count === 1 ? "w-full md:h-[400px] md:w-[300px] lg:h-[400px] lg:w-[300px]" : "aspect-[4/5] w-full"}`}>
						{primaryImage && (
							<img
								src={primaryImage}
								alt={`Azure dress ${data.style}`}
								loading="lazy"
								fetchPriority="low"
								decoding="async"
								width="600"
								height="750"
								className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
							/>
						)}

						{hoverImage && (
							<img
								src={hoverImage}
								alt=""
								loading="lazy"
								fetchPriority="low"
								decoding="async"
								width="600"
								height="750"
								className="absolute left-0 top-0 h-full w-full object-cover object-top opacity-0 transition-opacity duration-500 group-hover:opacity-100"
							/>
						)}

						<div className="absolute inset-0 bg-black opacity-20 transition-opacity duration-500 group-hover:opacity-40" />
						{show === "yes" && (
							<p className="absolute bottom-0 left-1/2 w-full -translate-x-1/2 bg-[#1f4c94]/75 px-3 text-center font-lora text-lg font-semibold text-white">{data.style}</p>
						)}
					</div>
				</Link>

				{count === 1 && (
					<div className="mt-3">
						<p className="hidden py-4 font-Jost-Regular text-textlight md:block">Explore the details, fit and finish of this Azure gown.</p>
					</div>
				)}
			</li>
		</div>
	);
}

export default memo(Featurelist);
